import { CartHeartIcon } from './CartHeartIcon';

/**
 * author: Michael Irigoyen
 * id CB11E82A-C290-44A7-B9FC-88F47CEF5BC5
 * name cart-heart
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cart-heart.svg
 * tags
 * - Shopping 
 */
export const ShoppingFavoriteIcon = CartHeartIcon;
export default ShoppingFavoriteIcon